import { Box } from '@mui/material';
import { ElementType, type ReactNode } from 'react';

type Props = {
  children: ReactNode;
  component?: ElementType;
};
/**
 * This component is specifically for making text accessible to screen readers while keeping it visually hidden from the page.
 */
export const AccessibleHiddenText = ({ children, component = 'div' }: Props) => {
  return (
    <Box
      sx={{
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
      }}
      component={component}
    >
      {children}
    </Box>
  );
};
